export var firebaseConfig = {
    apiKey: "AIzaSyBWnLHRm15oXB0cbFwU57dGPeR731Zmisg",
    authDomain: "test-project-5f054.firebaseapp.com",
    databaseURL: "https://test-project-5f054.firebaseio.com",
    projectId: "test-project-5f054",
    storageBucket: "test-project-5f054.appspot.com",
    messagingSenderId: "188260954291",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlyZWJhc2VDb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmaXJlYmFzZUNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxjQUFjLEdBQUc7SUFDNUIsTUFBTSxFQUFFLHlDQUF5QztJQUNqRCxVQUFVLEVBQUUsb0NBQW9DO0lBQ2hELFdBQVcsRUFBRSwyQ0FBMkM7SUFDeEQsU0FBUyxFQUFFLG9CQUFvQjtJQUMvQixhQUFhLEVBQUUsZ0NBQWdDO0lBQy9DLGlCQUFpQixFQUFFLGNBQWM7Q0FDbEMsQ0FBQyJ9